//Walls
export const wallGroupName = "wallGroup";
export const wallMeshName = "wallMesh";
export const wallMeshBBoxName = "wallMeshBBox";
export const raehmMeshName = "raehmMesh";

//Roof
export const roofGroupName = "roofGroup";
export const attikaMeshName = "attikaMesh";

//Floor
export const floorGroupName = "floorGroup";

//Cutouts
export const cutOutsGroupName = "cutOutsGroup";
export const controlObjectName = "controlObject";

export const pillarMeshName = "pillarMesh";
export const supportBeamMeshName = "supportBeamMesh";
export const schwelleMeshName = "schwelleMesh";
